import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import capitalize from 'rebook/apps/utils/text/capitalize';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import * as TagDetailActions from 'rebook/apps/catalog/actions/TagDetailActions';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';


class TagDetailView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(TagDetailActions.fetchInitialData(match));
  }

  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.TagDetailActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.TagDetailActions.resetData();
  }

  componentWillReceiveProps(nextProps) {
    // fetch context for new author slug
    const tagSlug = nextProps.match.params.tagSlug;
    if (tagSlug && tagSlug !== this.props.match.params.tagSlug) {
      this.props.TagDetailActions.resetData();
      this.props.TagDetailActions.fetchInitialData(nextProps.match, nextProps.location);
    }
  }

  changePage(pageNumber) {
    window.scrollTo(0, 0);
    this.props.TagDetailActions.fetchBookList({ pageNumber });
  }

  changeOrderBy(orderBy) {
    this.props.TagDetailActions.fetchBookList({ orderBy });
  }
  filterBySubscriptionType(subscriptionId) {
    this.props.TagDetailActions.fetchBookList({ subscriptionId });
  }
  changeBookType(bookType) {
    this.props.TagDetailActions.fetchBookList({ bookType });
  }
  resetFilters() {
    this.props.TagDetailActions.fetchBookList({
      subscriptionId: null,
      orderBy: 'popular',
      bookType: null,
    });
  }

  render() {
    const {
      tag, books, orderBy, pageNumber, lastPageNumber, totalBookCount, subscriptionId, bookType,
    } = this.props.tagDetail;
    const { location } = this.props;
    const isFilterShown = books && (books.length > 1) || get(location, 'search', false);

    return (
      <React.Fragment>
        <div className="section">
          {tag && (
            <React.Fragment>
              <BreadCrumbs links={[
                { text: 'Библиотека', url: '/catalog/' },
                { text: 'Темы', url: '/tags/' },
                { text: tag.name.charAt(0).toUpperCase() + tag.name.slice(1), url: '' },
              ]} />
              <CatalogHeader
                title={capitalize(tag.name)}
                bookCount={tag.active_book_count} />
            </React.Fragment>
          )}
          {isFilterShown
            ? (
              <CatalogFilter
                orderBy={orderBy}
                subscriptionId={subscriptionId}
                bookType={bookType}
                isResultEmpty={books && books.length === 0}
                onChangeSubscription={(value) => this.filterBySubscriptionType(value)}
                onChangeOrder={(value) => this.changeOrderBy(value)}
                onChangeBookType={((value) => this.changeBookType(value))}
                onResetFilter={()=>this.resetFilters()} />
            )
            : null
          }
          {books && books.length !== 0
            ? <BookList books={books} />
            : this.renderEmptyBooks(totalBookCount)
          }
          {lastPageNumber > 1 && (
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </React.Fragment>
    );
  }
  renderEmptyBooks(totalBookCount) {
    return totalBookCount === 0
      ? <EmptyFilterResult />
      : <BookList books={[...Array(5)]} />;
  }
}

TagDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tagSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    tagDetail: state.tagDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    TagDetailActions: bindActionCreators(TagDetailActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TagDetailView);
